// extracted by mini-css-extract-plugin
export default {"root":"hero-container_root__svceJ"};